<template>
  <div
    class="rounded-md shadow-lg border border-gray-200 bg-white overflow-hidden flex flex-col"
  >
    <span
      class="bg-primary h-full w-full
        min-h-[10px] min-w-[10px] laptop:min-h-[15px] laptop:min-w-[15px]"
    />

    <div
      class="relative"
    >
      <NuxtPicture
        src="images/component/userCard/background.png"
        loading="lazy"
        class="absolute inset-0"
      />

      <div
        class="relative z-10 mx-8 laptop:mx-16 my-12
          grid tablet:grid-rows-[8em_auto] laptop:grid-rows-[auto_auto] grid-cols-1 tablet:grid-cols-[8em_auto_auto] gap-8"
      >
        <!-- avatar -->
        <NuxtPicture
          :src="props.user?.id"
          sizes="128px"
          provider="xenos"
          class="overflow-hidden rounded-2xl flex laptop:row-span-2 mx-auto laptop:mx-0"
          :modifiers="{ scale: 16 }"
        />

        <!-- user name & level -->
        <div
          class="flex flex-row flex-wrap gap-2"
        >
          <h1
            v-if="props.user"
            class="h0 text-left text-white"
          >
            {{ props.user.name }}
          </h1>
          <span
            v-if="user"
            class="h0 text-white"
          >
            <span
              class="h1 text-white whitespace-nowrap"
            >
              {{ t('jc.component.userCard.level', { level: (props.user?.level || 0) }) }}
            </span>
          </span>
        </div>

        <!-- status -->
        <UserStatusChip
          :user="props.user"
          class="tablet:mb-auto tablet:ml-auto"
        />

        <!-- roles -->
        <div
          class="flex flex-row flex-wrap gap-2 mt-auto tablet:col-span-3 laptop:col-span-2"
        >
          <template
            v-for="role in (props.user?.roles || [])"
            :key="role"
          >
            <UserRoleChip
              :role-key="role"
            />
          </template>
          <UserRoleChip
            v-if="showTempPremium"
            :role-key="UserRole.PREMIUM"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { type User, UserRole } from '~/composables/charon'

const { t } = useI18n()

const props = defineProps<{
  user: User | null
}>()

const showTempPremium = computed(() => props.user?.premium && !props.user.roles?.includes(UserRole.PREMIUM))
</script>

<style scoped lang="postcss">
:deep(img) {
  @apply w-full h-full object-cover object-top
}
</style>
